import API from "@/services/api";

export default {
  searchGeo(table, params) {
    const { country, region, district, village } = params;
    return API().get(`/search/geo/${table}`, {
      params: {
        country,
        region,
        district,
        village,
      },
    });
  },
  searchName(table, name) {
    console.log(`searching: ${table} where name = ${name}`);
    return API().get(`/search/name/${table}`, {
      params: {
        name,
      },
    });
  },
  searchTeachers(name) {
    return API().get("/search/teachers/", {
      params: {
        name,
      },
    });
  },
  searchStudents(name) {
    return API().get("/search/students/", {
      params: {
        name,
      },
    });
  },
  searchClusterStudents(id,name) {
    return API().get(`/search/cluster/${id}/students/`, {
      params: {
        name,
      },
    });
  },
  searchTeachersGroup(group) {
    return API().get("/search/teachers/group", {
      params: {
        group,
      },
    });
  },
  searchStudentsGroup(group) {
    return API().get("/search/students/group", {
      params: {
        group,
      },
    });
  },
  searchStudentsTrainer(name, uuid) {
    return API().get(`/search/trainer/${uuid}/students/`, {
      params: {
        name,
      },
    });
  },
  searchStudentsCoordinator(name, uuid) {
    return API().get(`/search/coordinator/${uuid}/students/`, {
      params: {
        name,
      },
    });
  },
};
